"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.valid = [];
function validate(validator, target) {
    if (typeof validator === 'function') {
        return validator(target);
    }
    var refinedValidator = validator;
    var result = lodash_1.mapValues(refinedValidator, function (subValidator, key) {
        return validate(subValidator, target[key]);
    });
    return lodash_1.pickBy(result, function (errors) { return lodash_1.isArray(errors) ? (errors.length > 0) : (errors != null); });
}
exports.validate = validate;
exports.hasValidationErrors = function (result) {
    return lodash_1.some(result, function (validationErrors) {
        return lodash_1.isArray(validationErrors)
            ? validationErrors.length > 0
            : (validationErrors != null && exports.hasValidationErrors(validationErrors));
    });
};



//////////////////
// WEBPACK FOOTER
// ../composable-validation/dist/validate.js
// module id = 8
// module chunks = 0